@if ((product$ | async); as product) {
  <table>
    @for (productAttribute of productAttributeList; track productAttribute) {
      @if (product[productAttribute] && toCharacters(product[productAttribute]).length) {
        <tr>
          <th>{{('productDetails.technicalCharacteristics.' + productAttribute) | cxTranslate}}</th>
          <td>
            @if ((
              isArray(product[productAttribute])
              && product[productAttribute].length
              )) {
              <table>
                @for (attribute of product[productAttribute]; track attribute) {
                  @if (attribute?.name) {
                    <tr>
                      <td>
                        {{attribute.name}}
                      </td>
                    </tr>
                  } @else {
                    @if (attribute) {
                      <tr>
                        <td>
                          {{attribute}}
                        </td>
                      </tr>
                    }
                  }
                }
              </table>
            } @else {
              @if (toCharacters(product[productAttribute]).length) {
                @if (product[productAttribute]?.name) {
                  {{product[productAttribute].name}}
                } @else {
                  {{product[productAttribute]}}
                }
              }
            }
          </td>
        </tr>
      }
    }
  </table>
}
